import type { SheetOption } from '@/domains/mobile-web/components/BottomSheetMobile/BottomSheetMobile';
import type {
  RefundOrderProduct,
  RefundOrderShipping,
} from '@/domains/mobile-web/components/CardRefundOrder/CardRefundOrder';
import { BOOKS_DATA } from '@/domains/mobile-web/constant/listBook.constant';
import type { RefundStatusType } from '@/domains/mobile-web/constant/listStatusRefund.constant';

// Data statis halaman refund (sementara, sampai API refund tersedia).
// Gambar/harga contoh diambil dari katalog dummy; fallback agar aman jika index kosong.
const DANDELION_COVER = BOOKS_DATA[0]?.frontCover ?? null;
const LEBAH_COVER = BOOKS_DATA[1]?.frontCover ?? null;
const LEBAH_PRICE = BOOKS_DATA[1]?.price ?? 259900;

export const REFUND_PRODUCT_BUNDLING: RefundOrderProduct = {
  id: 'bundling',
  product: {
    id: 'bundling-30',
    title: 'Paket Bundling - 30 Buku Anak-Anak Lengkap',
    price: 3898000,
    author: null,
    frontCover: DANDELION_COVER,
  },
  quantity: 1,
};

export const REFUND_PRODUCT_LEBAH: RefundOrderProduct = {
  id: 'lebah',
  product: {
    id: 'lebah-kecil',
    title: 'Lebah Kecil Jumpa Bunga Stroberi',
    price: LEBAH_PRICE,
    author: 'Lee Ru-Mi',
    frontCover: LEBAH_COVER,
  },
  quantity: 1,
};

export const REFUND_STATIC = {
  date: '9 Sept 2026',
  invoice: 'INV/20241024/TKB/89421',
  refundCode: 'REFUND-202603100001',
  review: {
    reason: 'Buku Rusak',
    description: 'Buku yang saya beli robek',
    bank: 'bca',
    accountNumber: '5673214536',
    accountName: 'Budi Santoso',
  },
};

export const REFUND_REASONS = ['Buku Rusak', 'Buku tidak sesuai', 'Barang Kurang', 'Lainnya'];

export const REFUND_BANK_OPTIONS: SheetOption[] = [
  { value: 'bca', label: 'Bank BCA' },
  { value: 'bni', label: 'Bank BNI' },
  { value: 'mandiri', label: 'Bank Mandiri' },
  { value: 'bri', label: 'Bank BRI' },
];

export const REFUND_REJECTION_REASONS = [
  'Video bukti belum menunjukkan kondisi barang yang bermasalah dengan jelas.',
  'Pengajuan refund belum memenuhi ketentuan pengembalian yang berlaku.',
  'Kondisi barang tidak memenuhi persyaratan pengembalian.',
];

export const REFUND_COURIER_OPTIONS: SheetOption[] = [
  { value: 'jnt', label: 'J&T Express' },
  { value: 'jne', label: 'JNE' },
  { value: 'sicepat', label: 'SiCepat' },
  { value: 'anteraja', label: 'AnterAja' },
];

export const REFUND_NOTES = {
  unselected:
    'Buku yang tidak dipilih untuk pengajuan refund dianggap telah diterima dalam kondisi baik.',
  reviewProcess:
    'Pengajuan refund akan ditinjau oleh tim manajemen. Mohon tetap menyimpan barang yang akan direfund sampai ada instruksi selanjutnya.',
  shippingCost: 'Biaya pengiriman barang sepenuhnya ditanggung oleh pembeli.',
  returnProcess:
    'Pengembalian dana akan diproses paling lambat 2×24 jam setelah barang sampai di alamat pengembalian.',
};

export interface RefundListItem {
  id: string;
  date: string;
  code: string;
  status: RefundStatusType;
  products: RefundOrderProduct[];
  estimatedRefund: number;
  shipping?: RefundOrderShipping;
}

const REFUND_SHIPPING: RefundOrderShipping = {
  courier: 'J&T Express',
  trackingNumber: 'JT9823410924ID',
  note: 'Estimasi tiba besok sore • Paket sudah dihub sortir Jakarta Barat',
};

/** Satu kartu per status, urut seperti desain halaman daftar refund. */
const REFUND_LIST_SEED: Array<{ status: RefundStatusType; shipping?: RefundOrderShipping }> = [
  { status: 'review' },
  { status: 'rejected' },
  { status: 'approved' },
  { status: 'shipped', shipping: REFUND_SHIPPING },
  { status: 'arrived', shipping: REFUND_SHIPPING },
  { status: 'processing', shipping: REFUND_SHIPPING },
  { status: 'finished', shipping: REFUND_SHIPPING },
];

export const REFUND_LIST: RefundListItem[] = REFUND_LIST_SEED.map((item, index) => ({
  id: `refund-${index + 1}`,
  date: REFUND_STATIC.date,
  code: REFUND_STATIC.refundCode,
  status: item.status,
  products: [REFUND_PRODUCT_LEBAH],
  estimatedRefund: REFUND_PRODUCT_LEBAH.product.price,
  shipping: item.shipping,
}));
